import {useMutation} from "@apollo/client";
import {useContext, useEffect} from "react";
import {FormProvider, useForm} from "react-hook-form";

import Button from "@/components/button/Button.tsx";
import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {
  GQL_CREATE_SUBSCRIPTION_EMAIL_DOMAIN,
  GQL_SUBSCRIPTION_EMAIL_DOMAINS,
  GQL_SUBSCRIPTION_EMAIL_DOMAINS_COUNTS,
  UpdateSubscriptionEmailDomainResult,
} from "@/lib/queries/statuspages.ts";
import {ResponseStatus} from "@/lib/types/common.ts";
import {SubscriptionEmailDomainType} from "@/lib/types/statuspages.ts";
import {StatusPageContext} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";
import {setServerErrors} from "@/pages/vault/vaultForm/CredentialFormUtils.ts";

export interface AddDomainFormValues {
  domain: string;
}
export interface AddDomainTypeFormProps {
  domainType: SubscriptionEmailDomainType;
}

export const AddDomainForm = ({domainType}: AddDomainTypeFormProps) => {
  const {statusPage} = useContext(StatusPageContext);

  const methods = useForm<AddDomainFormValues>({
    defaultValues: {
      domain: "",
    },
  });
  const [addDomain, {loading, data}] = useMutation<UpdateSubscriptionEmailDomainResult>(
    GQL_CREATE_SUBSCRIPTION_EMAIL_DOMAIN,
    {
      refetchQueries: [GQL_SUBSCRIPTION_EMAIL_DOMAINS, GQL_SUBSCRIPTION_EMAIL_DOMAINS_COUNTS],
    }
  );
  const serverErrors = data?.response.message || {};
  const onSubmit = async (data: AddDomainFormValues) => {
    const response = await addDomain({
      variables: {
        statusPageID: statusPage.id,
        data: {
          domain_type: domainType,
          domain: data.domain,
        },
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      methods.reset();
    }
  };
  useEffect(() => {
    if (serverErrors) {
      setServerErrors(serverErrors, methods.setError, "");
    }
  }, [serverErrors, methods.setError]);
  return (
    <FormProvider {...methods}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          methods.handleSubmit(onSubmit)(e);
        }}
        noValidate={true}
      >
        <div className="d-flex flex-row gap-3">
          <InputField
            className="w-100"
            name="domain"
            placeholder={`Add ${domainType === SubscriptionEmailDomainType.ALLOWED ? "an allowed" : "a blocked"} domain`}
          />
          <Button type={"submit"} variant={"secondary"} disabled={loading}>
            Add
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};
